export enum ReasonCodes {
    SessionExpired = 'SESSION_EXPIRED',
    SessionLimitExceeded = 'SESSION_LIMIT_EXCEEDED',
    NormalLogout = 'NORMAL_LOGOUT',
    SelfExcluded = 'SELF_EXCLUDED',
    TimedOut = 'TIMED_OUT',
    TermsDeclined = 'TERMS_DECLINED',
    Suspended = 'SUSPENDED',
    PlayerClosed = 'PLAYER_CLOSED',
    CompanyClosed = 'COMPANY_CLOSED',
}

export interface ErrorCode {
    code?: string | number;
    field?: string;
}

const errorReasonCodesTranslation: Record<ReasonCodes, string> = {
    [ReasonCodes.SessionExpired]: 'pam.autologout.reasons.session_expired',
    [ReasonCodes.SessionLimitExceeded]: 'pam.autologout.reasons.session_limit_exceeded',
    [ReasonCodes.NormalLogout]: 'pam.autologout.reasons.normal_logout',
    [ReasonCodes.SelfExcluded]: 'pam.autologout.reasons.self_excluded',
    [ReasonCodes.TimedOut]: 'pam.autologout.reasons.timed_out',
    [ReasonCodes.TermsDeclined]: 'pam.autologout.reasons.terms_declined',
    [ReasonCodes.Suspended]: 'pam.autologout.reasons.suspended',
    [ReasonCodes.PlayerClosed]: 'pam.autologout.reasons.player_closed',
    [ReasonCodes.CompanyClosed]: 'pam.autologout.reasons.company_closed',
};

export function getTranslatedReasonCode(reasonCode: ReasonCodes): string {
    return errorReasonCodesTranslation[reasonCode];
}

export function getTranslatedErrorCode(errorCode: ErrorCode): string {
    if (errorCode.field) {
        return errorCode.code ? `pam.errors.fields.${errorCode.field}.${errorCode.code}` : `pam.fields.${errorCode.field}`;
    }
    return errorCode.code ? `pam.errors.general.${errorCode.code}` : 'pam.general.unknown_error';
}
